import {useContext} from "react";
import {UtilityDataContext} from "../utilities/contexts";

const withUtilities = (WrappedComponent) => (props) => {
  const {utilityData, utilityDataLoaded} = useContext(UtilityDataContext);

  if (utilityDataLoaded && utilityData) {
    return <WrappedComponent {...props} />;
  } else {
    return null;
  }
};

export default withUtilities;
